let funnel_keyboard_navigation = false;
let recent_slide_first_focus_elem = $("#select-license-header").get(0);
let segment_viewed_tracked = {};

$(document).ready(function() {
    if (page_info.counselor_earnings && ($('#full-time-range').length > 0 || $('#part-time-range').length > 0)) {
        let $slider = $('#full-time-range');
        let eventLabel = 'full_time';
        if (page_info.show_part_time_earnings) {
            $slider = $('#part-time-range');
            eventLabel = 'part_time';
        }
        let totalAmount = page_info.counselor_earnings[$slider.prop('value')];

        if (!page_info.show_part_time_earnings && page_info.earnings_calculator_v2) {
            totalAmount += page_info.health_stipend['per_year'];
            const localeCode = navigator.language;
            $('#health-stipend-amount').text(displayCurrencyAmount(page_info.health_stipend['per_year'], page_info.earning_calculator_currency.abbr, localeCode));
        }

        setCalculatorEarningValues(totalAmount, $slider.prop('value'));
        apply_fill($slider);
        EarningsCalculatorV2Events('viewed', eventLabel).send();
    }

    //clear error when focuses on form element
    $('input').focusout(function (event) {
        $(this).parents('.form-group, .form-floating').removeClass("has-error");
    })
    $('.form-select').focusout(function (event) {
        $(this).removeClass("has-error");
    })

    $(".counselor_question").removeClass('hidden');

    // if the user is on the select, click the radio button don't just select it (which is default browser behavior)
    $('.slider-next-select').on('click', function (event) {
        event.preventDefault();
        $('.slider-next-button', this).trigger('click');
    });

    $('.slider-next-button').on('click', function (event) {
        event.stopPropagation();

        const counselor_funnel = $('#counselor-funnel');
        if (counselor_funnel.hasClass('first-slide')) {
            TherapistOnboardingMilestoneEvent('quiz_start').send();

            counselor_funnel.removeClass('first-slide');
            $('#counselor-banner-intro-title').addClass('hidden');
            $('#counselor-funnel-disclaimer') ? $('#counselor-funnel-disclaimer').addClass('hidden') : '';
        }

        handle_counselor_question_slider($(this), event);
    });

    function handle_counselor_question_slider(slide, event) {
        const form_errors = $("#form_errors");
        if (slide.attr('id') !== 'counselor-info') {
            form_errors.addClass('hidden');
            send_therapist_quiz_answer_event(slide);
            $("#counselor-question-slider").slick('slickNext');
            return;
        }

        event.preventDefault();
        const first_name = $("#first_name").val();
        const last_name = $("#last_name").val();
        const email = $("#applicant_email").val();
        const state_id = $("#applicant_state").val();
        const $counselorInfoBtn = $('#counselor-info');

        if (
            first_name.trim().length <= 0
            || last_name.trim().length <= 0
            || email.trim().length <= 0
            || (!page_info.UK_quiz && state_id <= 0)
        ) {
            form_errors.text('Please complete the application form');
            focus_on_signup_error_input(false);
            form_errors.removeClass('hidden');
            resize_dynamic_slide();
            return;
        }

        $counselorInfoBtn.attr('disabled', true);
        $.ajax({
            url: "/api/validate_counselor_application/",
            type: "POST",
            data: {email: email, csrf_token: page_info.csrf_token}
        }).done(function (data) {
            if(data.status === "success") {
                form_errors.addClass('hidden');
                $("#counselor-question-slider").slick('slickNext');
                submit_funnel_form();
            } else {
                form_errors.text('Email is invalid, please try again');
                focus_on_signup_error_input(true);
                $('#email_error').text('Please enter a valid email address');
                form_errors.removeClass('hidden');
                resize_dynamic_slide();
                $counselorInfoBtn.attr('disabled', false);
            }
        });
    }

    function send_therapist_quiz_answer_event(question) {
        const questionId = $(question).data('question-id');
        const questionText = $(question).closest('.form-group').find('.questionnaire-content-label').text();
        const answerText = $(question).parent()[0].innerText;
        TherapistQuizAnswerEvent(questionId, questionText, answerText).send();
    }

    $(document).on('mousedown', function (e) {
        funnel_keyboard_navigation = false;
    });

    $(document).on('keydown', function (e) {
        let tabbables;
        // If Shift+ESC is pressed, exit funnel and tab to next focusable element.
        if (e.which == 27 && e.shiftKey && ($.contains($('#counselor-question-slider').first().get(0), document.activeElement) || $('#select-license-header').is(document.activeElement))) {
            tabbables = $(':focusable');
            const last_slider_focusable_index = tabbables.index($('#counselor-question-slider').find(':focusable').last());
            tabbables.eq(last_slider_focusable_index + 1).focus();
            e.preventDefault();
            return false;
        }

        // Ensure that tab+shift does not go to the counselor account creation form prematurely when tabbed on an element after the funnel
        if (e.which == 9 && e.shiftKey) {
            tabbables = $(':focusable');
            const active_elem_index = tabbables.index(document.activeElement);
            const last_focusable_slider_elem_index = tabbables.index($('#counselor-question-slider').find(':focusable').last());

            // if the user has escaped (shift+esc) from the funnel and tries to go back (shift+tab), focus on the most recent funnel question
            // this is necessary so that shift+tab does not go to the Next button of the account info form
            if (recent_slide_first_focus_elem && active_elem_index > -1 && active_elem_index == last_focusable_slider_elem_index + 1) {
                const recent_slide_first_focus_elem_index = tabbables.index(recent_slide_first_focus_elem);
                tabbables.eq(recent_slide_first_focus_elem_index).focus();
                e.preventDefault();
                return false;
            }
        }

        if ($('#counselor-question-slider').length) {
            // tab, enter, page up, page down, left arrow, up arrow, right arrow, down arrow
            const control_keys = new Array(9, 13, 33, 34, 37, 38, 39, 40);

            if ($.inArray(e.which, control_keys) > -1) {
                funnel_keyboard_navigation = true;
                const focus_elem = document.activeElement;
                if (!$.contains($('#counselor-question-slider').first().get(0), focus_elem) && !$('#select-license-header').is(focus_elem)) {
                    return true;
                }

                // The legend on the first slide ("select license") is hidden, so it is not tabbable. The h2 header is used instead to show the funnel question.
                // For the first slide, make the header the first_focus_elem. This is needed in order to tab through the question and cycle through.
                let first_focus_elem;
                if ($('#counselor-funnel').hasClass('first-slide')) {
                    first_focus_elem = $("#select-license-header").get(0);
                } else {
                    first_focus_elem = $('#counselor-question-slider .slick-active').find('label.questionnaire-content-label, legend.questionnaire-content-label, .slider-next-select:visible, a:visible:not(.disabled), select:visible, input:visible:not(:disabled), .tabbable, .btn').first().get(0);
                }

                recent_slide_first_focus_elem = first_focus_elem;
                const last_focus_elem = $('#counselor-question-slider .slick-active').find('label.questionnaire-content-label, legend.questionnaire-content-label, .slider-next-select:visible, a:visible:not(.disabled), select:visible, input:visible:not(:disabled):not([tabindex="-1"]), .tabbable, .btn').last().get(0);

                if (e.which == 9) {
                    if (!$.contains($('.slick-active').first().get(0), focus_elem) && !$('#select-license-header').is(focus_elem)) {
                        $(first_focus_elem).focus();
                        e.preventDefault();
                        return false;
                    }
                    if (e.shiftKey && focus_elem === first_focus_elem) {
                        $(last_focus_elem).focus();
                        e.preventDefault();
                        return false;
                    }
                    if (!e.shiftKey && focus_elem === last_focus_elem) {
                        $(first_focus_elem).focus();
                        e.preventDefault();
                        return false;
                    }
                }

                if (e.which == 13 && !$(focus_elem).hasClass('dropdown-toggle')) {
                    $(focus_elem).trigger('click');
                    e.preventDefault();
                    return false;
                }
                return true;
            }
        }
        return true;
    });

    $('#counselor-question-slider').on('afterChange', function(event, slick, currentSlide){
        const first_focus_elem = $('#counselor-question-slider .slick-active').find('label.questionnaire-content-label, legend.questionnaire-content-label, .slider-next-select:visible, a:visible:not(.disabled), select:visible, input:visible:not(:disabled), .tabbable, .btn, h2').first().get(0);

        $(first_focus_elem).focus();

        recent_slide_first_focus_elem = first_focus_elem;
    });

    $('input[type=radio][name=employment-type]').on('change', function() {
        const slider = $(this.value === 'part-time' ? '#part-time-range' : '#full-time-range');
        let new_estimate_value = page_info.counselor_earnings[slider.prop('value')];
        if ($('.salary-rate-selector--options:checked').val() === 'per_month') {
            new_estimate_value = page_info.monthly_counselor_earnings[slider.prop('value')];
        }
        new_estimate_value += calculateHealthStipend(slider.prop('value'));
        $('.part-time-range-container').toggleClass('hidden');
        $('.full-time-range-container').toggleClass('hidden');
        setCalculatorEarningValues(new_estimate_value, slider.prop('value'));
        apply_fill(slider);
        set_bubble();

        const label = this.value === 'part-time' ? 'part_time' : 'full_time';
        EarningsCalculatorV2Events('I_want_to_work_option_clicked', label).send();
    });

    $('input[type=range][name=ft-range]').on('input change', function() {
        let new_earning = page_info.counselor_earnings[this.value];
        if ($('.salary-rate-selector--options:checked').val() === 'per_month') {
            new_earning = page_info.monthly_counselor_earnings[this.value];
        }
        new_earning += calculateHealthStipend(this.value);
        setCalculatorEarningValues(new_earning, this.value);
    });

    $('input[type=range][name=pt-range]').on('input change', function() {
        let new_earning = page_info.counselor_earnings[this.value];
        if ($('.salary-rate-selector--options:checked').val() === 'per_month') {
            new_earning = page_info.monthly_counselor_earnings[this.value];
        }
        new_earning += calculateHealthStipend(this.value);
        setCalculatorEarningValues(new_earning, this.value);
    });

    if (page_info.earnings_calculator_v2) {
        $(".hours-per-week-tooltip").bootstrap_tooltip({
            placement: 'top',
            title: '<div>' + $('.hours-per-week-tooltip:visible').data('text') + '</div>',
            html: true,
        });

        $("i.fa.fa-circle-info").hover(function () {
            const parent = $(this).parent();
            if (parent.length > 0) {
                let action = null;
                let label = null;
                if (parent.attr('id') === 'counselor-earnings-tooltip') {
                    action = 'estimated_earnings_tooltip_viewed';
                } else if (parent.attr('id') === 'surge-earnings-tooltip') {
                    action = 'bonus_tooltip_viewed';
                    label = $('.salary-rate-selector--options:checked').val();
                } else if (parent.hasClass('hours-per-week-tooltip')) {
                    action = 'hours_per_week_tooltip_viewed';
                }

                sendEarningsCalculatorEvent(action, label);
            }
        });

        const $salaryCheckbox = $('#salary-rate-selector-checkbox');
        const $salarySelectorOptions = $('.salary-rate-selector--options');

        $salarySelectorOptions.on('change', function () {
            const checkedOption = $('.salary-rate-selector--options:checked');
            updateSalarySelect(checkedOption);
            $salaryCheckbox.prop('checked', false);
        });

        $salaryCheckbox.on('change', function () {
            if (this.checked) {
                $('#salary-rate-selector-dropdown').css('display', 'block');
                document.addEventListener('click', handleSalaryClosure);
            }
        });

        function updateSalarySelect(salary) {
            let employmentType = 'part-time';
            if ($('input[type=radio][name=employment-type]').length > 0) {
                $('input[type=radio][name=employment-type]:checked').val();
            }

            const slider = $(employmentType === 'part-time' ? '#part-time-range' : '#full-time-range');
            let new_estimate_value = page_info.counselor_earnings[slider.prop('value')];
            let healthStipendRate = 'year';
            let action = 'per_year_clicked';
            if (salary.val() === 'per_month') {
                healthStipendRate = 'month';
                new_estimate_value = page_info.monthly_counselor_earnings[slider.prop('value')];
                action = 'per_month_clicked';
            }
            new_estimate_value += calculateHealthStipend(slider.prop('value'));
            $('#health-stipend-rate').text(healthStipendRate);
            setCalculatorEarningValues(new_estimate_value, slider.prop('value'));
            $('#salary-rate-selector-label-text').html(salary.next().text());
            $('i.fa-check').addClass('hidden');
            salary.parent().find('i.fa-check').removeClass('hidden');
            apply_fill(slider);
            set_bubble();
            sendEarningsCalculatorEvent(action);
        }

        function handleSalaryClosure(e) {
            if (e.target.id === 'salary-rate-selector-label') {
                e.preventDefault();
            }
            $('#salary-rate-selector-dropdown').css('display', 'none');
            $salaryCheckbox.prop('checked', false);
            document.removeEventListener('click', handleSalaryClosure);
        }
    }

    function calculateHealthStipend(total_hours) {
        if (!page_info.earnings_calculator_v2) {
            return 0;
        }

        let healthStipend = 0;
        const salaryRate = $('.salary-rate-selector--options:checked').val();
        if (page_info.health_stipend && total_hours >= 30) {
            healthStipend = page_info.health_stipend[salaryRate];
        }

        if (healthStipend) {
            const localeCode = navigator.language;
            $('#health-stipend-amount').text(displayCurrencyAmount(healthStipend, page_info.earning_calculator_currency.abbr, localeCode));
            $('#health-stipend-container').removeClass('hidden');
        } else if (!$('#health-stipend-container').hasClass('hidden')) {
            $('#health-stipend-container').addClass('hidden');
        }

        return healthStipend;
    }

    function calculate_surge_bonus (total_hours) {
        if (page_info.surge_data !== undefined) {
            const discount_factor = 0.35;
            let surge_earning_estimate = Math.round(52 * total_hours * page_info.surge_data.surge_rate * discount_factor);

            if (page_info.earnings_calculator_v2) {
                const salaryRate = $('.salary-rate-selector--options:checked').val();
                if (salaryRate === 'per_month') {
                    surge_earning_estimate = Math.round(surge_earning_estimate / 12);
                }
            }
            const localeCode = navigator.language;
            $('#surge-earnings-amount').text(displayCurrencyAmount(surge_earning_estimate, page_info.earning_calculator_currency.abbr, localeCode));
        }
    }

    function setCalculatorEarningValues(newEarning, sliderValue) {
        const localeCode = navigator.language;
        $('#earnings-amount').text(displayCurrencyAmount(newEarning, page_info.earning_calculator_currency.abbr, localeCode));
        $('#earnings-amount').attr("data-earning", newEarning);
        calculate_surge_bonus(sliderValue);
    }

    $('#counselor_application #counselor-earnings-btn, #counselor_application .get-started-counselor-application, #counselor_application .therapist-get-started').on('click', function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#counselor-funnel").offset().top - 90
        }, 1000);
    });

    if (document.body.clientWidth <= 726) {
        $('#counselor-earning-desc').addClass('hidden');
    }

    $("#counselor-earnings-tooltip").bootstrap_tooltip({
        placement: 'top',
        title: translateTooltipTitle('<div>' + $("#counselor-earnings-tooltip").data('text') + '</div>'),
        html: true,
    });
    $("#surge-earnings-tooltip").bootstrap_tooltip({
        placement: 'top',
        title: translateTooltipTitle('<div>' + $("#surge-earnings-tooltip").data('text') + '</div>'),
        html: true,
    });

    set_bubble();

    // range fill start
    $('#full-time-range').on('input', function() {
        apply_fill($('#full-time-range'));
        sendEarningsCalculatorEvent('slider_moved', $(this).val());
    })

    $('#part-time-range').on('input', function() {
        apply_fill($('#part-time-range'));
        sendEarningsCalculatorEvent('slider_moved', $(this).val());
    })
    // range fill end

    $('input[type=checkbox]').click(function() {
        const question_id = $(this).data('question-id');
        if($("input.checkbox_" + question_id + ":checkbox:checked").length > 0) {
            $('#select-' + question_id).prop('disabled', false);
        } else {
            $('#select-' + question_id).prop('disabled', true);
        }
    });

    if ($('#counselor-question-slider').length > 0) {
        $('#counselor-question-slider').slick({
            infinite: false,
            adaptiveHeight: true,
            arrows: false,
            swipeToSlide: false,
            draggable: false,
            swipe: false,
            touchMove: false,
            speed: 400,
            accessibility: false,
            mobileFirst: true,
            initialSlide: 0,
        });
    }

    if ($('.testimonial-slider').length > 0) {
        $('.testimonial-slider').slick({
            dots: true,
            infinite: false,
            adaptiveHeight: true,
            arrows: false,
            swipe: true,
            swipeToSlide: true,
            autoplay: true,
            autoplaySpeed: 7000
        });
    }

    Counter.init();

    const get_started_button = $('.get-started-counselor-application');
    const application = $('#counselor_application_form');
    const header = $('header');
    if(get_started_button.length && application.length && header.length){
        get_started_button.on('click', function(e){
            e.preventDefault();
            $(window).scrollTop(application.offset().top - header.outerHeight(true) - 10);
        })
    }

    if(page_info.use_sweeps) {
        $('#counselor-funnel').submit(function(event) {
            if(typeof zaraz !== 'undefined') {
                zaraz.track('CounselorFunnelComplete', {});
            }
        });
    }

    $('select.form-control').select2({ minimumResultsForSearch: Infinity });
    $('.mobilemenu-toggle').on('touchstart', () => {
        $('select.form-control').select2('close');
    })

    $(window).on("scroll", visibleHeader);
    visibleHeader();

    $('.form-select').focusout(function (event) {
        $(this).find('.select2-container--focus').removeClass('select2-container--focus');
    });


    function is_scrolled_into_view(elem, offset = 200) {
        const doc_view_top = $(window).scrollTop();
        const doc_view_bottom = doc_view_top + $(window).height();
        const elem_top = $(elem).offset().top;
        const elem_bottom = elem_top + offset;
        return ((elem_bottom <= doc_view_bottom) && (elem_top >= doc_view_top));
    }

    function sendEarningsCalculatorEvent(action, label = null) {
        if (page_info.earnings_calculator_v2) {
            EarningsCalculatorV2Events(action, label).send();
        }
    }

    $('.comparison_table_tooltip').each(function () {
        $(this).bootstrap_tooltip({
            placement: document.body.clientWidth < 550 ? 'top' : 'right',
            title: translateTooltipTitle('<div>' + $(this).data('text') + '</div>'),
            html: true,
        });

        const label = $(this).closest('.table-comparison-text').text().trim();

        $(this).click(() => {
            if (page_info['cna_id']) {
                new TherapistSignupComparison('click_i', page_info['cna_id'], label).send();
            }
        });
    });

    window.addEventListener('scroll', () => {
        if (segment_viewed_tracked['comparison'] === undefined && is_scrolled_into_view('#betterhelp-in-office-comparison')) {
            segment_viewed_tracked['comparison'] = true;
            if (page_info['cna_id']) {
                new TherapistSignupComparison('table_viewed', page_info['cna_id']).send();
            }
        }
    });

    // Counselor counter
    Counter.init();

    $('.scroll-top').on('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});

function submit_form() {
    $('#counselor_application_form').submit();
}

function submit_funnel_form() {
    $('#counselor-funnel').submit();
}

function set_bubble() {
    const allRanges = document.querySelectorAll(".range-wrap");
    allRanges.forEach(function(wrap) {
        const range = wrap.querySelector(".range");
        const bubble = wrap.querySelector(".bubble");
        range.addEventListener("input", function() {
            get_bubble(range, bubble);
        });
        get_bubble(range, bubble);
    });
}

function get_bubble(range, bubble) {
    const val = range.value;
    const min = range.min ? range.min : 0;
    const max = range.max ? range.max : 100;
    const newVal = Number(((val - min) * 100) / (max - min));
    bubble.innerHTML = val;
    bubble.style.left = 'calc(' + newVal + '% + (' + (8 - newVal * 0.15) + 'px))';
}

function apply_fill(slider) {
    const color_full = slider.data('slider-color-full') ?? '#4775AF';
    const color_empty = slider.data('slider-color-empty') ?? '#C5C5C5';
    const percentage = 100*(slider.val()-slider.prop('min'))/(slider.prop('max')-slider.prop('min'));
    const bg = 'linear-gradient(90deg, ' + color_full + ' ' + percentage +'%, ' + color_empty + ' '  + (percentage + 0.1) + '%)';
    slider.css("background", bg)
}

function focus_on_signup_error_input(is_invalid_email) {
    const first_name = $("#first_name").val();
    const last_name = $("#last_name").val();
    const email = $("#applicant_email").val();
    const state_id = $("#applicant_state").val();
    const country = $("#country_select");

    $('#counselor_questionnaire_info input').removeAttr('aria-describedby');
    $('#counselor_questionnaire_info select').removeAttr('aria-describedby');

    let focus_target = null;

    if (first_name.trim().length == 0) {
        focus_target = focus_target ?? $('#first_name');
        input_error_handling($('#first_name_error'));
    }
    if (last_name.trim().length == 0) {
        focus_target = focus_target ?? $('#last_name');
        input_error_handling($('#last_name_error'));
    }
    if (email.trim().length == 0 || is_invalid_email) {
        focus_target = focus_target ?? $('#applicant_email');
        $('#email_error').text('Please enter email address');
        input_error_handling($('#email_error'));
    }
    if (country.length && !country.val()) {
        focus_target = focus_target ?? $('#country_select');
    }
    if (!page_info.UK_quiz && !state_id) {
        focus_target = focus_target ?? $('#applicant_state');
        input_error_handling($('#applicant_state_error'));
    }

    if (focus_target) {
        focus_target.attr('aria-describedby', 'form_errors').focus();
    }
}

function input_error_handling(element) {
    element.removeClass('hidden');
    element.parent().addClass('has-error');
}

function resize_dynamic_slide() {
    $('.slick-list').height('auto');
    $('.slick-slide').height('auto');
}
